import { useEffect, useState } from "react";

export const useCurrentPage = (ids) => {
  const [visibleDiv, setVisibleDiv] = useState(null);

  useEffect(() => {
    const observers: any = [];

    const handleIntersect = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisibleDiv(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, {
      threshold: 0.5, // Adjust threshold as needed
    });

    ids.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        observer.observe(element);
        observers.push({ id, observer });
      }
    });

    return () => {
      observers.forEach(({ observer }) => observer.disconnect());
    };
  }, [ids]);

  return visibleDiv;
};

export default useCurrentPage;
